<div class="dialog-container">
  <img class="image" src="{{ data.fragment.data }}" />
  <button mat-flat-button mat-dialog-close class="close-button">
    <i class="material-icons">close</i>
    <span class="text-capitalize">{{ 'close' | translate }}</span>
  </button>
</div>
